"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

var _toConsumableArray = require("/codebuild/output/src2284469283/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.is-array");

var _objectWithoutProperties = require("/codebuild/output/src2284469283/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/codebuild/output/src2284469283/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = resolveConfig;

var _some = _interopRequireDefault(require("lodash/some"));

var _mergeWith = _interopRequireDefault(require("lodash/mergeWith"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _defaults = _interopRequireDefault(require("lodash/defaults"));

var _map = _interopRequireDefault(require("lodash/map"));

var _get = _interopRequireDefault(require("lodash/get"));

var _toPath = _interopRequireDefault(require("lodash/toPath"));

var _negateValue = _interopRequireDefault(require("./negateValue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var configUtils = {
  negative: function negative(scale) {
    return Object.keys(scale).filter(function (key) {
      return scale[key] !== '0';
    }).reduce(function (negativeScale, key) {
      return _objectSpread(_objectSpread({}, negativeScale), {}, _defineProperty({}, "-".concat(key), (0, _negateValue["default"])(scale[key])));
    }, {});
  },
  breakpoints: function breakpoints(screens) {
    return Object.keys(screens).filter(function (key) {
      return typeof screens[key] === 'string';
    }).reduce(function (breakpoints, key) {
      return _objectSpread(_objectSpread({}, breakpoints), {}, _defineProperty({}, "screen-".concat(key), screens[key]));
    }, {});
  }
};

function value(valueToResolve) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (0, _isFunction["default"])(valueToResolve) ? valueToResolve.apply(void 0, args) : valueToResolve;
}

function mergeThemes(themes) {
  var theme = function (_ref) {
    var _ = _ref.extend,
        t = _objectWithoutProperties(_ref, ["extend"]);

    return t;
  }(themes.reduce(function (merged, t) {
    return (0, _defaults["default"])(merged, t);
  }, {}));

  return _objectSpread(_objectSpread({}, theme), {}, {
    // In order to resolve n config objects, we combine all of their `extend` properties
    // into arrays instead of objects so they aren't overridden.
    extend: themes.reduce(function (merged, _ref2) {
      var extend = _ref2.extend;
      return (0, _mergeWith["default"])(merged, extend, function (mergedValue, extendValue) {
        if ((0, _isUndefined["default"])(mergedValue)) {
          return [extendValue];
        }

        if (Array.isArray(mergedValue)) {
          return [extendValue].concat(_toConsumableArray(mergedValue));
        }

        return [extendValue, mergedValue];
      });
    }, {})
  });
}

function mergeExtensions(_ref3) {
  var extend = _ref3.extend,
      theme = _objectWithoutProperties(_ref3, ["extend"]);

  return (0, _mergeWith["default"])(theme, extend, function (themeValue, extensions) {
    // The `extend` property is an array, so we need to check if it contains any functions
    if (!(0, _isFunction["default"])(themeValue) && !(0, _some["default"])(extensions, _isFunction["default"])) {
      return _objectSpread(_objectSpread({}, themeValue), Object.assign.apply(Object, [{}].concat(_toConsumableArray(extensions))));
    }

    return function (resolveThemePath, utils) {
      return _objectSpread(_objectSpread({}, value(themeValue, resolveThemePath, utils)), Object.assign.apply(Object, [{}].concat(_toConsumableArray(extensions.map(function (e) {
        return value(e, resolveThemePath, utils);
      })))));
    };
  });
}

function resolveFunctionKeys(object) {
  var resolveThemePath = function resolveThemePath(key, defaultValue) {
    var path = (0, _toPath["default"])(key);
    var index = 0;
    var val = object;

    while (val !== undefined && val !== null && index < path.length) {
      val = val[path[index++]];
      val = (0, _isFunction["default"])(val) ? val(resolveThemePath, configUtils) : val;
    }

    return val === undefined ? defaultValue : val;
  };

  return Object.keys(object).reduce(function (resolved, key) {
    return _objectSpread(_objectSpread({}, resolved), {}, _defineProperty({}, key, (0, _isFunction["default"])(object[key]) ? object[key](resolveThemePath, configUtils) : object[key]));
  }, {});
}

function extractPluginConfigs(configs) {
  var allConfigs = [];
  configs.forEach(function (config) {
    allConfigs = [].concat(_toConsumableArray(allConfigs), [config]);
    var plugins = (0, _get["default"])(config, 'plugins', []);

    if (plugins.length === 0) {
      return;
    }

    plugins.forEach(function (plugin) {
      if (plugin.__isOptionsFunction) {
        plugin = plugin();
      }

      allConfigs = [].concat(_toConsumableArray(allConfigs), _toConsumableArray(extractPluginConfigs([(0, _get["default"])(plugin, 'config', {})])));
    });
  });
  return allConfigs;
}

function resolveConfig(configs) {
  var allConfigs = extractPluginConfigs(configs);
  return (0, _defaults["default"]).apply(void 0, [{
    theme: resolveFunctionKeys(mergeExtensions(mergeThemes((0, _map["default"])(allConfigs, function (t) {
      return (0, _get["default"])(t, 'theme', {});
    })))),
    variants: function (firstVariants) {
      return Array.isArray(firstVariants) ? firstVariants : (0, _defaults["default"]).apply(void 0, [{}].concat(_toConsumableArray((0, _map["default"])(allConfigs, 'variants'))));
    }((0, _defaults["default"]).apply(void 0, [{}].concat(_toConsumableArray((0, _map["default"])(allConfigs)))).variants)
  }].concat(_toConsumableArray(allConfigs)));
}